import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, withLatestFrom } from 'rxjs';
import { exhaustMap, mergeMap } from 'rxjs/operators';
import { EntryCyclesActions } from '../actionstypes/entry-cycles/entry-cycles.actiontype';
import * as EntryCycleIdAction from '../actionstypes/selected-id/entry-cycle-id.actiontype';
import * as SitesAction from '../actionstypes/sites/sites.actiontype';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { getSelectedEntryCycle } from '../selectors/entry-cycles.selector';

@Injectable()
export class EntryCycleIdEffect {
  private readonly actions$ = inject(Actions);
  private readonly store = inject<Store<DataEntryStore>>(Store);

  entryCyclesGetEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntryCyclesActions.get),
      withLatestFrom(this.store.select(getSelectedEntryCycle)),
      mergeMap(([, selectedEntryCycle]) => {
        const entryCycle = selectedEntryCycle;
        return of(entryCycle?.id !== undefined ? new EntryCycleIdAction.Set(entryCycle.id) : new EntryCycleIdAction.Reset());
      }),
    ),
  );

  setEntryCycleId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntryCycleIdAction.EntryCycleIdAction.Set),
      exhaustMap(({ entryCycleId }) => {
        localStorage.setItem('selectedEntryCycleId', String(entryCycleId));

        return of(new SitesAction.Load());
      }),
    ),
  );
}
